import React from 'react';
import { List, ListItem, Typography, Dialog, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, } from '@mui/material';
// icons
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { grey } from '@mui/material/colors';
// custom components

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='left' ref={ref} {...props} />;
});

export default function ClosureNotes({ showClosureNotes, setShowClosureNotes }) {
  const handleClose = () => {
    setShowClosureNotes(null)
  }

  return (
    <Dialog open={Boolean(showClosureNotes)} TransitionComponent={Transition} keepMounted maxWidth='xs' fullWidth className='notes-modal'
      onClose={handleClose}
      aria-describedby='alert-dialog-slide-description'
    >
      <DialogTitle id='draggable-dialog-title' display='flex' alignItems='center' justifyContent='space-between' mb={0.5}>
        {'Closure Notes'}
        <IconButton onClick={handleClose} edge='end' size='small'>
          <CloseIcon fontSize='medium' />
        </IconButton>
      </DialogTitle>
      <DialogContent className='notes-modal-body'>
        <DialogContentText id='alert-dialog-slide-description'>
          <List>
            <ListItem>
              <Typography variant='body2' fontWeight='medium'>
                {
                  showClosureNotes?.closureNotes?.split("\n")?.map((text, i) => (
                    <>
                      {text && <span key={i} style={{ color: grey[600] }}>{text || "-"}</span>}
                      <br />
                    </>
                  ))
                }
              </Typography>
            </ListItem>
          </List>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}